<template>
  <td>
    <h6
      class="custom-margin-h6-table"
      v-if="infoData.contact_positions.length > 0"
    >
      <strong>{{ $t('common_words.contacts') }}: </strong>
    </h6>
    <span v-for="(contact, index) in contactsInfo" :key="index">
      <el-tag type="info" style="height: auto; width: auto"
        ><span
          >{{ $t('common_words.name') }}: {{ getContactName(contact) }} <br />
          {{ $t('common_words.position') }}:
          {{ getContactPosition(contact, index) }} <br />
          {{ $t('common_words.phone_shortversion') }}:
          {{ getContactPhone(contact, index) }}</span
        ></el-tag
      >
    </span>
  </td>
</template>
<script>
export default {
  name: 'td-contacts-info',
  props: {
    contactsInfo: {
      required: true,
    },
    infoData: {
      type: Object,
      default: () => {
        return {
          contact_positions: [],
          contact_phones: [],
        };
      },
    },
  },
  methods: {
    getContactName(contact) {
      if (contact.name) {
        return contact.name;
      } else {
        return contact;
      }
    },
    getContactPosition(contact, index) {
      if (contact.position) {
        return contact.position;
      } else {
        return this.infoData.contact_positions[index];
      }
    },
    getContactPhone(contact, index) {
      if (contact.phone) {
        return contact.phone;
      } else {
        return this.infoData.contact_phones[index];
      }
    },
  },
};
</script>
